export function FounderProfileDisplay({ userDetails }) {
	return (
		<div className="p-4 flex flex-col gap-4">
			{userDetails.details.picture && (
				<div>
					<img
						className="rounded-md"
						src={userDetails.details.picture}
						width={300}
						height={300}
						alt="details picture"
					/>
				</div>
			)}
			<div className="flex gap-4">
				<div>Name: </div>
				<div className="font-extrabold">{`${userDetails.firstName || ''} ${userDetails.lastName || ''}`}</div>
			</div>
			<div className="flex gap-4">
				<div>Email: </div>
				<a className="font-extrabold underline" href={"mailto:" + userDetails.email}>
					{userDetails.email}
				</a>
			</div>
			<div className="flex gap-4">
				<div>Position: </div>
				<div className="font-extrabold">{(userDetails.details.positions || userDetails.positions)?.join(", ")}</div>
			</div>
			<div className="flex gap-4">
				<div>Address: </div>
				<div className="font-extrabold">
					{[
						userDetails.details.address,
						userDetails.details.city,
						userDetails.details.country || userDetails.details.locatedCountry,
					].join(", ")}
				</div>
			</div>
			<div className="flex gap-4">
				<div>LinkedIn URL: </div>
				<a href={userDetails.details.linkedinUrl} target="_blank" rel="noreferrer" className="font-extrabold underline">
					{userDetails.details.linkedinUrl}
				</a>
			</div>
			<div className="flex gap-4">
				<div>Degree: </div>
				<div className="font-extrabold">{userDetails.details.degree || userDetails.details.details?.academicDegreeCategory || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Professional Degree: </div>
				<div className="font-extrabold">{userDetails.details.details?.professionalDegree || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Expertise / Business Experience: </div>
				<div className="font-extrabold">{userDetails.details.expertise || userDetails.details.details?.businessExperience || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Had Prior Exits?: </div>
				<div className="font-extrabold">{userDetails.details.hadExit || userDetails.details.details?.hadExit || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Last Employment Duration: </div>
				<div className="font-extrabold">{userDetails.details.lastEmploymentDuration || userDetails.details.details?.lastEmploymentDuration || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Remuneration Type: </div>
				<div className="font-extrabold">{userDetails.details.remuneration || userDetails.details.details?.remuneration || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Time Commitment: </div>
				<div className="font-extrabold">{userDetails.details.timeCommitment || userDetails.details.details?.timeCommitment || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Renumeration: </div>
				<div className="font-extrabold">{userDetails.details.remuneration || userDetails.details.details?.remuneration || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Shall Refer To Coach: </div>
				<div className="font-extrabold">{userDetails.details.shallReferToCoach || userDetails.details.details?.shallReferToCoach || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Reason For Idea: </div>
				<div className="font-extrabold">{userDetails.details.reason || userDetails.details.details?.reason || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Had an Award: </div>
				<div className="font-extrabold">{userDetails.details.hadaward || userDetails.details.details?.hadaward || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Certification: </div>
				<div className="font-extrabold">{userDetails.details.certification || userDetails.details.details?.certification || ''}</div>
			</div>
			<div className="flex gap-4">
				<div>Is Mentored: </div>
				<div className="font-extrabold">{userDetails.details.isMentored || userDetails.details.details?.isMentored || ''}</div>
			</div>
		</div>
	);
}
